import React from 'react'
import PropTypes from 'prop-types'

import { View } from 'react-native'

import {
  Icon,
  VFText,
  VFButton,
  QuickActionMenu,
} from '@vfgroup-oneplatform/foundation/Components'

import Images from '../../Themes/Images'

import styles from './LeaveGroupWarning.Style'

const LeaveGroupWarning = ({ show, onClose, onConfirm }) => {
  return (
    <QuickActionMenu
      title="unlimited_leave_group_button"
      type="secondary"
      isVisible={show}
      toggleModal={onClose}
    >
      <View style={styles.container}>
        <View style={styles.main}>
        <Icon name={Images.leave} size={120} type="image" />
          <VFText
            style={styles.title}
            placeHolders={['Aida']}
            i18nKey="unlimited_leave_group_title"
          />
          <VFText
            style={styles.descriptionText}
            i18nKey="unlimited_notify_when_leave"
          />
        </View>
        <VFButton
          onPress={onConfirm}
          title="unlimited_continue"
          style={styles.continueButton}
        />
        <VFButton
          onPress={onClose}
          type="secondary"
          title="unlimited_back"
          style={styles.backButton}
        />
      </View>
    </QuickActionMenu>
  )
}

LeaveGroupWarning.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func
}

LeaveGroupWarning.defaultProps = {
  show: false,
  onClose: () => {},
  onConfirm: () => {}
}

export default LeaveGroupWarning
